import React from 'react'
import { useFormContext, useFormState } from 'react-hook-form'
import styles from './PostalCodeField.module.css'

// Composant pour le cas isActiveSubmit = true
const ActivePostalCodeField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  const input_style = field.input_design ? { ...field.input_design } : {}
  const formContext = useFormContext()
  const register = formContext.register
  const inputProps = register(field.idFieldCanvas.toString(), {
    required: field.required,
    minLength: {
      value: 5,
      message: 'Le code postal doit contenir exactement 5 chiffres',
    },
    maxLength: {
      value: 5,
      message: 'Le code postal doit contenir exactement 5 chiffres',
    },
    pattern: {
      value: /^[0-9]{5}$/,
      message: 'Le code postal doit être composé de 5 chiffres',
    },
  })

  let inputClass = ''

  if (isSubmitted) {
    inputClass = error ? 'input-error' : 'input-success'
  }

  return (
    <div className={styles.bloc}>
      <input
        {...inputProps}
        defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
        type="text"
        className={inputClass}
        style={input_style || {}}
        placeholder={field.placeholder || ''}
      />
      {error && <p className="error__message">{error.message}</p>}
    </div>
  )
}

// Composant pour le cas isActiveSubmit = false
const InactivePostalCodeField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  return (
    <input
      defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
      type="text"
      style={input_style || {}}
      placeholder={field.placeholder || ''}
    />
  )
}

const PostalCodeField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActivePostalCodeField field={field} control={control} />
  ) : (
    <InactivePostalCodeField field={field} />
  )
}

export default PostalCodeField
